import styled, { type CSSObject } from '@emotion/styled';
import { Maybe } from 'graphql/jsutils/Maybe';
import FixedNextImage from '../../NextImage/FixedNextImage';
import { useTheme } from '@emotion/react';

const flourishSize = 350;

const InitialsFlourishWrapper = styled('div')`
  position: relative;
  z-index: -1; // Prevents InitialsFlourish from rendering on top of the site title
  img {
    width: ${flourishSize}px;
    height: ${flourishSize}px;
  }

  ${(props): CSSObject | undefined => props.theme.components.InitialsLockup}
`;

export interface InitialsFlourishProps {
  firstName: Maybe<string>;
  fianceFirstName: Maybe<string>;
  themeId: Maybe<number>;
}

const InitialsFlourish = ({
  firstName,
  fianceFirstName,
  themeId,
}: InitialsFlourishProps) => {
  const theme = useTheme();

  if (!firstName || !fianceFirstName || !themeId) {
    return null;
  }

  const flourishSrc = `${process.env['FLOURISH_DOMAIN']}/lockup/initials?firstName=${firstName}&fianceFirstName=${fianceFirstName}&themeId=${themeId}`;
  const flourishAlt = `${firstName} & ${fianceFirstName}`;

  return (
    <InitialsFlourishWrapper>
      <FixedNextImage
        height={flourishSize}
        width={flourishSize}
        src={flourishSrc}
        alt={flourishAlt}
        imageCSSObject={theme.components.InitialsLockup}
        loading="eager"
        priority
        skipUrlProcessing
      />
    </InitialsFlourishWrapper>
  );
};

export default InitialsFlourish;
